import type {Theme} from '@emotion/react';

interface VariablesProps {
    theme: Theme;
}

/**
 * Generates CSS custom properties for FilterSelectInput base styling.
 *
 * @param props       The properties object.
 * @param props.theme The theme object containing color values.
 * @returns CSS string with custom properties for selected color and cursor states.
 */
export const getBaseVariables = ({theme}: VariablesProps) => `
    --selected-color: ${theme.colors.primary};
    --cursor: pointer;

    &[data-has-error=true] {
        --selected-color: ${theme.colors.error};
    }

    &[data-is-disabled=true] {
        --selected-color: ${theme.colors.neutral40};
        --cursor: not-allowed;
    }
`;